module.exports = __webpack_public_path__ + "img/Manitou.comV4.446ac4bc.png";